module.exports = __webpack_public_path__ + "static/media/info_grey.74cb4b26.svg";